

// src/pages/Cart.jsx
import React from "react";

const Cart = () => {
  return (
    <div className="p-8">
      <h2 className="text-2xl font-bold mb-4">Your Cart</h2>
      <p>This is the cart page.</p>
    </div>
  );
};

export default Cart;
